(function() {
  'use strict';
  
  angular
    .module('app.shell')
    .controller('ShellController', ShellController);
      
  ShellController.$inject = [
    '$log', 
    '$state', 
    '$mdDialog',
    '$mdSidenav',
    '$window',
    'auth',
    'shell'
  ];
    
  function ShellController(
      $log,
      $state,
      $mdDialog,
      $mdSidenav,
      $window,
      auth,
      shell
    ) {
    $log = $log.getInstance('ShellController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.action = null;
    vm.goBack = goBack;
    vm.goToState = goToState;
    vm.isState = isState;
    vm.logout = logout;
    vm.openExternal = openExternal;
    vm.openLeftMenu = openLeftMenu;
    vm.shell = shell;

    
    function goBack() {
      $state.go(vm.shell.back.state, vm.shell.back.stateParams);
    }
    
    function goToState(state, params) {
      $state.go(state, params);
      $mdSidenav('left').close();
    }
    
    function isState(stateName, stateParams) {
      var result = $state.current.name.lastIndexOf(stateName, 0) === 0;
      if (stateParams)
        result &= _.matcher(stateParams)($state.params);
      return result;
    }
    
    function logout() {
      $state.go('auth.logout');
    }
    
    function openExternal (url) {
      $window.open(
        url,
        '_blank',
        'toolbar=yes, location=yes, status=yes, menubar=yes, scrollbars=yes'
      );
    }
    
    function openLeftMenu() {
      $mdSidenav('left').toggle();
    }
  }
  
})();